import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import solutionquote2 from "../../public/svg/quote4.svg";

const SolutionContentPage = () => {
   return (
      <>
         <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 flex justify-center items-center'>
            <div className='rounded lg:p-14'>
               <div className='lg:px-8  relative text-center'>
                  <h4 className='font-extrabold lg:text-3xl '>Agility. Productivity. Opportunity</h4>
                  <p className='pt-1 lg:text-4xl'>Streamline your campus hiring with EasyCampus to stay competitive and ahead of the curve.
                  </p>
               </div>
               <div className='grid grid-cols-1 lg:grid-cols-12 lg:gap-10 mt-10'>
                  <div className='col-span-1 lg:col-span-4 lg:flex'>
                     <div className='lg:ml-[33.5%] -mt-12'>
                        <Image src={solutionquote2} alt='preparing for a job interview' className='w-20 h-20' />
                     </div>
                     <h4 className='lg:ml-10 lg:text-[27px] lg:text-end font-extrabold'>Corporates</h4>
                  </div>
                  <div className='col-span-1 lg:col-span-8'>
                     <h4 className='lg:text-[27px] font-extrabold'>Streamlined Campus Drives</h4>
                     <p className='text-xl leading-7 mt-2'> Our comprehensive campus drive suite handles the entire process, making it easier to balance work and life even with limited staff and tight deadlines. This solution significantly enhances your business operations, smoothing out the hiring process and improving efficiency.
                     </p>
                     <Link href="https://app.easycampus.in/registration" target="_blank" data-toggle="modal" data-target="#Easycampus">
                        <button className=" mt-2 comic-button font-medium overflow-hidden relative px-4 py-2 rounded-md hover:brightness-150  active:opacity-75 outline-none duration-300 group">
                           <span className="bg-teal-700 shadow-teal-700 absolute -top-[150%] left-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
                           Sign Up
                        </button>
                   </Link>
                  </div>
               </div>
               <div className='grid grid-cols-1 lg:grid-cols-12 lg:gap-10 my-6'>
                  <div className='col-span-1 lg:col-span-4'>
                     <h4 className='lg:text-end lg:text-[27px] font-extrabold'>Colleges/Universities</h4>
                  </div>
                  <div className='col-span-1 lg:col-span-8'>
                     <h4 className='lg:text-[27px] font-extrabold'>Unified Campus Placement Solution</h4>
                     <p className='text-xl leading-7 mt-2'>Our automated and highly secure platform ensures top-notch data protection and provides a seamless end-to-end process. It offers ample opportunities for hassle-free campus drives, free from geographical limitations.</p>
                     <Link href="https://app.easycampus.in/registration" target="_blank" data-toggle="modal" data-target="#Easycampus">
                        <button className=" mt-2 text-teal-600 comic-button font-medium overflow-hidden relative px-4 py-2 rounded-md hover:brightness-150  active:opacity-75 outline-none duration-300 group">
                           <span className="bg-teal-700 shadow-teal-700 absolute -top-[150%] left-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
                           Sign Up
                        </button>
                   </Link>
                  </div>
               </div>
               <div className='grid grid-cols-1 lg:grid-cols-12 lg:gap-10'>
                  <div className='col-span-1 lg:col-span-4'>
                     <h4 className='lg:text-[27px] lg:text-end font-extrabold'>Students</h4>
                  </div>
                  <div className='col-span-1 lg:col-span-8'>
                     <h4 className='lg:text-[27px] font-extrabold'>More Opportunities to Thrive</h4>
                     <p className='text-xl leading-7 mt-2'>Our transparent process offers a clear view of employment expectations versus reality, playing a crucial role in shaping your career. EasyCampus is dedicated to ensuring you have the clarity and support needed to reach your full potential.</p>
                     <Link href="https://app.easycampus.in/registration" target="_blank" data-toggle="modal" data-target="#Easycampus">
                        <button className=" mt-2 text-teal-600 comic-button font-medium overflow-hidden relative px-4 py-2 rounded-md hover:brightness-150  active:opacity-75 outline-none duration-300 group">
                           <span className="bg-teal-700 shadow-teal-700 absolute -top-[150%] left-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
                           Sign Up
                        </button>
                   </Link>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default SolutionContentPage